const pallete = [
	'#5b9379',
	'#d3c061',
	'#e79975',
	'#799e73',
	'#e4c169',
	'#e17a64',
	'#97aa6d',
	'#efc160',
	'#dc5b53',
	'#b5b567',
	'#ecad60',
	'#d94c4a',
];

export default pallete;
